<form *ngIf="vm$ | async as vm" [formGroup]="form" class="container-fluid">
  <mat-tab-group
    [dynamicHeight]="true"
    [preserveContent]="true"
    (selectedIndexChange)="onTabindexChange($event)"
    [selectedIndex]="activeIndex"
    *ngIf="pageItemTypes$ | async as pageItemTypes"
  >
    <mat-tab [label]="'Content pages'" *ngIf="pageItemTypes?.content" aria-label="content-pages-menu-item" >
      <ng-container
        *ngTemplateOutlet="
          pageActionsTemplate;
          context: { buttonTypeText: '', formControl: formControls.contentPageFilter, pageType: PageType.content }
        "
      ></ng-container>
      <osn-cxb-page-list
        [isLoading]="vm.isLoading"
        [pages]="vm.contentPages"
        [data-testid]="'page-screen-content-page-list'"
        [tenantSpecificActions]="pageItemTypes?.content?.actions"
      ></osn-cxb-page-list>
    </mat-tab>

    <mat-tab [label]="'Marketing pages'" *ngIf="pageItemTypes?.marketing" aria-label="marketing-pages-menu-item">
      <osn-cxb-page-list
        [isLoading]="vm.isLoading"
        [pages]="vm.marketingPages"
        [showType]="true"
        [data-testid]="'page-screen-marketing-page-list'"
        [tenantSpecificActions]="pageItemTypes?.marketing?.actions"
      ></osn-cxb-page-list>
    </mat-tab>

    <mat-tab [label]="'Redeem pages'" *ngIf="pageItemTypes?.redeem" aria-label="redeem-pages-menu-item">
      <ng-container
        *ngTemplateOutlet="
          pageActionsTemplate;
          context: { buttonTypeText: 'redeem', formControl: formControls.redeemPageFilter, pageType: PageType.redeem }
        "
      ></ng-container>
      <osn-cxb-page-list
        [isLoading]="vm.isLoading"
        [pages]="vm.redeemPages"
        [showType]="true"
        [showTargeting]="true"
        [tenantSpecificActions]="pageItemTypes?.redeem?.actions"
        [data-testid]="'page-screen-redeem-page-list'"
      ></osn-cxb-page-list>
    </mat-tab>

    <mat-tab [label]="'Genre pages'" *ngIf="pageItemTypes?.genre" aria-label="genre-pages-menu-item">
      <ng-container
        *ngTemplateOutlet="
          pageActionsTemplate;
          context: { buttonTypeText: 'genre', formControl: formControls.genrePageFilter, pageType: PageType.genre }
        "
      ></ng-container>
      <osn-cxb-page-list
        [isLoading]="vm.isLoading"
        [pages]="vm.genrePages"
        [showAttachedGenre]="true"
        [tenantSpecificActions]="pageItemTypes?.genre?.actions"
        [data-testid]="'page-screen-genre-page-list'"
      ></osn-cxb-page-list>
    </mat-tab>
    <!-- TODO
        reenable when reintroducing collection pages
    <mat-tab [label]="'Collection pages'">
      <ng-container
        *ngTemplateOutlet="
          pageActionsTemplate;
          context: { buttonTypeText: 'collection', formControl: formControls.collectionPageFilter, pageType: PageType.collection }
        "
      ></ng-container>

      <osn-cxb-page-list [isLoading$]="vm.isLoading$" [pages]="vm.collectionPages" [showAttachedGenre]="true"></osn-cxb-page-list>
    </mat-tab>
 -->
  </mat-tab-group>
</form>

<ng-template #pageActionsTemplate let-buttonTypeText="buttonTypeText" let-formControl="formControl" let-pageType="pageType">
  <div class="d-flex my-3">
    <mat-form-field class="with-prefix search-input d-flex align-items-center mr-3" *ngIf="accesses.screen.launcherScreen.searchPages">
      <input matInput type="text" autocomplete="off" [placeholder]="'Filter pages'" [formControl]="formControl" />
      <svg-icon matPrefix key="search"></svg-icon>
      <span class="close-icon" (click)="formControl.setValue('')" matSuffix>
        <svg-icon *ngIf="formControl.value" key="cancel"></svg-icon>
      </span>
    </mat-form-field>

    <button
      *ngIf="accesses.screen.launcherScreen.createNewPage"
      (click)="onCreateNewPageClick(pageType)"
      data-testid="page-screen-create-page-btn"
    >
      <svg-icon key="plus-bold" size="sm" class="mr-2"></svg-icon>Create new {{ buttonTypeText ? buttonTypeText + ' ' : '' }}page
    </button>
  </div>
</ng-template>
